
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-md">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{"New Subscription"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="">
            <div class="form-group">
              <label class="form-label">User</label>
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="user_id" (change)="changeUser()"  [(ngModel)]="user" class="selectpicker font-oswald w-100" data-live-search="true">
                <option *ngFor="let user of allusers" [value]="user?.id">{{user?.email | titlecase}}</option>
              </select>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['user_id']?.errors?.['required'] && f2['user_id'].touched && f2['user_id']?.invalid">
                  Please select user.
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">Subscription</label>
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300"formControlName="subscription_code" class="selectpicker font-oswald w-100">
                <ng-container *ngFor="let data of subscriptions | keyvalue">
                  <optgroup label="{{data.key | titlecase}}" *ngIf="userRoleMatch(data.key,user)">
                    <option *ngFor="let subscription of data.value" [value]="subscription?.code">{{subscription?.title+" "+subscription.period | titlecase}}</option>
                  </optgroup>
                </ng-container>
              </select>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['subscription_code']?.errors?.['required'] && f2['subscription_code'].touched && f2['subscription_code']?.invalid">
                  Please select subscription.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>